import React, { useEffect } from 'react';

const CodingChallenge = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: CodingChallenge is not implemented yet.');
  }, []);
  return (
    <>
  { /*CodingChallenge */} 
 </>
  );
};

export default CodingChallenge;
